import { Eye, FileClock, Scale, ShieldCheck, Users } from 'lucide-react'
import { useTranslation } from 'react-i18next'

const MOAT_ITEMS = [
  { key: 'integrity', icon: FileClock },
  { key: 'fairness', icon: Scale },
  { key: 'governance', icon: ShieldCheck },
  { key: 'auditability', icon: Eye },
  { key: 'isolation', icon: Users },
] as const

/**
 * PR-121: five verifiable trust claims, each pairing a plain-language title
 * with a description of an actual, shipped behavior — not an adjective on
 * its own. Every description here maps to a real SDD requirement (SEC-002,
 * SEC-006, audit trail in `06-security-privacy-ops.md` §5) so the copy can
 * never drift ahead of what the system actually does (see `BR-112`).
 */
export function CoreMoatSection() {
  const { t } = useTranslation('home')

  return (
    <section className="flex flex-col gap-4 pt-1 pb-4 md:pt-2 md:pb-6">
      <div className="flex flex-col gap-1">
        <h2 className="text-2xl font-semibold tracking-tight sm:text-3xl">
          {t('coreMoat.heading')}
        </h2>
        <p className="text-lg text-muted-foreground">{t('coreMoat.description')}</p>
      </div>
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-5">
        {MOAT_ITEMS.map(({ key, icon: Icon }) => (
          <div key={key} className="flex flex-col gap-2 rounded-xl border border-border p-4">
            <Icon className="size-7 text-primary" aria-hidden="true" />
            <h3 className="font-medium">{t(`coreMoat.items.${key}.title`)}</h3>
            <p className="text-sm text-muted-foreground">
              {t(`coreMoat.items.${key}.description`)}
            </p>
          </div>
        ))}
      </div>
    </section>
  )
}
